<div class="row">
    <div class="col-xs-12">
        <div class="main-box">
            <header *ngIf="step3FormSubmitted && selectedFourDotFiveAdmin.length == 0"
                class="main-box-header clearfix col-xs-offset-2 col-xs-10">
                <h2 class="has-error"><span class="help-block"> <em>*</em>
                        {{MESSAGECONSTANTS.COMPANY_MANAGEMENT.ENTER_MANDATORY_FIELDS}}</span>
                </h2>
            </header>
            <div class="main-box-body clearfix" style="margin-top:10px;padding-bottom:0px;">
                <div class="col-lg-6">
                    <h2 style="color: #03a9f4;">
                        <b>4dot5 Admin</b>
                    </h2>
                    <form role="form" #company4dot5AdminDetailsForm="ngForm"
                        [ngClass]="{'disabledworkflow1': !isFourDotFiveSuperUser}"
                        style="padding-left:16px;margin-top:10px;">
                        <label for="fourDotFiveAdmin">{{MESSAGECONSTANTS.COMPANY_MANAGEMENT.NAME}}
                            <em> * </em> : </label>
                        <div class="form-group"
                            [ngClass]="{'has-error': (step3FormSubmitted && !selectedAdmin),'disablemultiselect' : !isFourDotFiveSuperUser,'validatemultiselect': (selectedFourDotFiveAdmin.length == 0 && step3FormSubmitted)}">
                            <ng-select name="fourDotFiveAdmin" id="fourDotFiveAdmin" [items]="fourDotFiveAdminsList"
                                bindLabel="fullName" dropdownPosition="bottom" placeholder="None Selected" [clearable]="true" [searchable]="true"
                                [ngModel]="selectedAdmin" (ngModelChange)="onSelectedAdminChange($event)" required>
                            </ng-select>
                        </div>
                        <div class="form-group table-responsive">
                            <label for="fourDotFiveAdmin"
                                style="font-weight: 700;">{{MESSAGECONSTANTS.COMPANY_MANAGEMENT.SCOPES}}</label>
                            <table style="width: 40%;" class="table borderless">
                                <tbody>
                                    <tr style="font-size: 15px;">
                                        <td *ngIf="companyManagement.company.companyType == 'StaffingCompany'">
                                            {{MESSAGECONSTANTS.COMPANY_MANAGEMENT.CLIENT}}
                                        </td>
                                        <td *ngIf="companyManagement.company.companyType == 'Corporation'">
                                            {{MESSAGECONSTANTS.COMPANY_MANAGEMENT.BU}}
                                        </td>
                                        <td style="margin-left: 0.2%;"><span class="label label-primary scopesall"> All
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- User Configuration -->
<div class="row">
    <div class="col-xs-12">
        <div class="main-box">
            <div class="main-box-body clearfix">
                <br>
                <h2 style="color: #03a9f4;">
                    <b>User Configuration</b>
                </h2>
                <br />
                <div class="row" style="padding-left: 8px;">
                    <div class="col-xs-12 col-md-12 col-lg-11" style="margin-top:0px;padding:0px;padding-left: 8px;">
                        <p class="text-danger" *ngIf="companyDetailsUpdateMode">Note:
                            All current users will need to change their passwords to conform to the new rule</p>
                        <table class="table table-bordered table-responsive user-configuration-table">
                            <thead>
                                <tr>
                                    <th>User Type</th>
                                    <th colspan="3">Password</th>
                                </tr>
                                <tr>
                                    <th style="width:5%"></th>
                                    <th style="width:25%">Length</th>
                                    <th style="width:55%">Complexity</th>
                                    <th style="width:15%">Expiration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let passwordConfiguration of companyManagement.userConfiguration.passwordSettings">
                                    <td>
                                        <h4 *ngIf="passwordConfiguration.userType == 'user'">User</h4>
                                        <h4 *ngIf="passwordConfiguration.userType == 'administrator'">Administrator</h4>
                                    </td>
                                    <td>
                                        <div class="row">
                                            <div class="col-xs-12" style="display: grid;grid-template-columns: 1fr 2fr;grid-gap: 5px;">
                                                <label>
                                                    Restrictions:
                                                </label>
                                                <div>
                                                    <div class="comp-management-radio" style="display:inline-block">
                                                        <input type="radio" name="passwordLengthRestriction-{{passwordConfiguration.userType}}"
                                                            id="passwordLengthRestrictionEnabled-{{passwordConfiguration.userType}}" [value]="true"
                                                            [(ngModel)]="passwordConfiguration.lengthRestrictionEnabled">
                                                        <label for="passwordLengthRestrictionEnabled-{{passwordConfiguration.userType}}">Yes</label>
                                                    </div>
                                                    <div class="comp-management-radio" style="display:inline-block">
                                                        <input type="radio" name="passwordLengthRestriction-{{passwordConfiguration.userType}}"
                                                            id="passwordLengthRestrictionDisabled-{{passwordConfiguration.userType}}"
                                                            [value]="false" [(ngModel)]="passwordConfiguration.lengthRestrictionEnabled">
                                                        <label for="passwordLengthRestrictionDisabled-{{passwordConfiguration.userType}}">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="display: grid;grid-template-columns: 1fr 2fr;grid-gap: 5px;"
                                            *ngIf="passwordConfiguration.lengthRestrictionEnabled">
                                            <label for="passwordLength-{{passwordConfiguration.userType}}" style="font-size: 13px;">Minimum
                                                Length:</label>
                                            <select class="form-control password-expiry-duration" style="display: inline-block;"
                                                name="passwordLength-{{passwordConfiguration.userType}}"
                                                id="passwordLength--{{passwordConfiguration.userType}}"
                                                [(ngModel)]="passwordConfiguration.minimumLength" required>
                                                <option *ngFor="let availableLength of passwordConfiguration.availableMinimumLengths"
                                                    [value]="availableLength">{{availableLength}}</option>
                                            </select>
                                        </div>
                                        <span class="text-danger"
                                            *ngIf="isMinimumLengthGreater(passwordConfiguration.minimumLength,passwordConfiguration.maximumLength)">
                                            Minimum length cannot be greater than maximum length
                                        </span>
                                        <div style="display: grid;grid-template-columns: 1fr 2fr;grid-gap: 5px;"
                                            *ngIf="passwordConfiguration.lengthRestrictionEnabled">
                                            <label for="passwordLength-max-{{passwordConfiguration.userType}}" style="font-size: 13px;">Maximum
                                                Length:</label>
                                            <select class="form-control password-expiry-duration" style="display: inline-block;"
                                                name="passwordLength-max-{{passwordConfiguration.userType}}"
                                                id="passwordLength-max-{{passwordConfiguration.userType}}"
                                                [(ngModel)]="passwordConfiguration.maximumLength" required>
                                                <option *ngFor="let availableLength of passwordConfiguration.availableMaximumLengths"
                                                    [value]="availableLength">{{availableLength}}</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <label style="margin-right:10px">
                                            Restrictions:
                                        </label>
                                        <div class="comp-management-radio" style="display:inline-block">
                                            <input type="radio" name="passwordComplexityRestriction-{{passwordConfiguration.userType}}"
                                                id="passwordComplexityRestrictionEnabled-{{passwordConfiguration.userType}}" [value]="true"
                                                [(ngModel)]="passwordConfiguration.complexityRestrictionEnabled">
                                            <label for="passwordComplexityRestrictionEnabled-{{passwordConfiguration.userType}}">Yes</label>
                                        </div>
                                        <div class="comp-management-radio" style="display:inline-block">
                                            <input type="radio" name="passwordComplexityRestriction-{{passwordConfiguration.userType}}"
                                                id="passwordComplexityRestrictionDisabled-{{passwordConfiguration.userType}}" [value]="false"
                                                [(ngModel)]="passwordConfiguration.complexityRestrictionEnabled">
                                            <label for="passwordComplexityRestrictionDisabled-{{passwordConfiguration.userType}}">No</label>
                                        </div>
                                        <div class="row" *ngIf="passwordConfiguration.complexityRestrictionEnabled" style="font-size: 13px;">
                                            <label class="col-xs-12">The password has to have: </label>
                                            <div class="col-xs-12" id="checkbox-group-{{passwordConfiguration.userType}}">
                                                <div class="checkbox-nice"
                                                    *ngFor="let complexity of passwordConfiguration.complexityRestrictions; let i = index"
                                                    [ngClass]="{'col-xs-6 col-md-4': i%2 ==0, 'col-xs-6': i%2 !== 0}">
                                                    <input type="checkbox" id="complexity-{{passwordConfiguration.userType}}-{{i}}"
                                                        name="complexityRestriction-{{passwordConfiguration.userType}}-{{i}}"
                                                        [(ngModel)]="complexity.enabled"
                                                        (ngModelChange)="onComplexityRestrictionChange(passwordConfiguration.userType)">
                                                    <label for="complexity-{{passwordConfiguration.userType}}-{{i}}" style="font-size: 13px;"
                                                        class="licensePreferenceName">
                                                        {{complexity.restriction}}
                                                    </label>
                                                </div>
                                            </div>
                                            <span style="padding-left:10px" id="checkbox-warning-{{passwordConfiguration.userType}}"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <select class="form-control password-expiry-duration text-center"
                                            name="passwordExpiration-{{passwordConfiguration.userType}}"
                                            id="passwordExpiration-{{passwordConfiguration.userType}}"
                                            [(ngModel)]="passwordConfiguration.daysToExpire" required>
                                            <option *ngFor="let days of passwordConfiguration.daysToExpireOptions" [value]="days">{{days}}</option>
                                        </select>
                                        <label for="passwordExpiration-{{passwordConfiguration.userType}}"> days</label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <label>
                            Two factor authentication required(sent via email):
                        </label>
                        <div class="comp-management-radio" style="display:inline-block">
                            <input type="radio" name="multiFactorAuthentication" id="multiFactorAuthenticationEnabled"
                                [value]="true"
                                [(ngModel)]="companyManagement.userConfiguration.multiFactorAuthenticationEnabled">
                            <label for="multiFactorAuthenticationEnabled">Yes</label>
                        </div>
                        <div class="comp-management-radio" style="display:inline-block">
                            <input type="radio" name="multiFactorAuthentication" id="multiFactorAuthenticationDisabled"
                                [value]="false"
                                [(ngModel)]="companyManagement.userConfiguration.multiFactorAuthenticationEnabled">
                            <label for="multiFactorAuthenticationDisabled">No</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- User management end-->
